module.exports = __webpack_public_path__ + "static/pedragon-64476a6bb34c6b161b8c5cd00b01470e.png";